import script from "./FinalView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinalView.vue?vue&type=script&setup=true&lang=js"

import "./FinalView.vue?vue&type=style&index=0&id=30e0323e&lang=scss"

const __exports__ = script;

export default __exports__